import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { injectStyle } from "react-toastify/dist/inject-style";

if (typeof window !== "undefined") {
  injectStyle();
}

const ManageAllOrders = () => {
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    fetch("https://young-hamlet-12954.herokuapp.com/manageAll")
      .then((res) => res.json())
      .then((data) => {
        setCustomers(data);
      });
  }, []);

  // update
  const updateStatus = (id) => {
    fetch(`https://young-hamlet-12954.herokuapp.com/manageAll/${id}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(customers),
    });
    toast.dark("Updated successfully!");
  };

  // delete
  const deleteOrder = (id) => {
    const proceed = window.confirm("Are you sure you want to delete?");
    if (proceed) {
      fetch(`https://young-hamlet-12954.herokuapp.com/deleteOrder/${id}`, {
        method: "DELETE",
        headers: { "content-type": "application/json" },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.deletedCount > 0) {
            const remaining = customers.filter((cs) => cs._id !== id);
            setCustomers(remaining);
            toast.dark("Deleted successfully!");
          }
        });
    }
  };

  return (
    <div className="container mt-1">
      <h1 className="text-center fw-bold">Manage All Orders</h1>
      <Table striped bordered hover responsive>
        <thead>
          <tr className="text-center">
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Product</th>
            {/* <th>Date</th> */}
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {customers?.map((cs, index) => (
            <tr className="text-center" key={cs._id}>
              <td>{index + 1}</td>
              <td>{cs?.name}</td>
              <td>{cs?.email}</td>
              <td>{cs?.product}</td>
              {/* <td>{cs?.date}</td> */}
              <td className="text-center">
                <button
                  onClick={() => {
                    updateStatus(cs?._id);
                  }}
                  className="btn btn-custom p-2 me-2"
                >
                  Update
                </button>
                <button
                  onClick={() => {
                    deleteOrder(cs?._id);
                  }}
                  className="btn btn-delete p-2 text-white"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <ToastContainer />
      {/* Modal  */}
      {/* <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Delete Booking
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">Are you sure you want to delete?</div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => confirmDelete(true)}
              >
                Yes
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => confirmDelete(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default ManageAllOrders;
